module.exports = __webpack_public_path__ + "images/1ae906cc8ad7272e069e1faff6d23c17.svg";